import { Route } from "react-router-dom";

import { PageLayout } from "../../layouts/page-layout/PageLayout";
// import { ListAPIPage } from "../verticals/pages/ListAPIPage";
// import Playground from "../verticals/components/Playground/Playground";
// import { Susbcription } from "../verticals/components/Subscription/Susbcription";
import { FullPageLayout } from "../../layouts/fullpage-payout/FullPageLayout";

function useVerticalsRoutes() {
  return (
    <Route path="verticals" element={<FullPageLayout />}>
      <Route path="" element={<PageLayout showLogsAndNotifications={false} />}>
        {/* <Route path="" element={<ListAPIPage />} />
        <Route path="playground/:id" element={<Playground />} />
        <Route path="subscriptions" element={<Susbcription />} /> */}
      </Route>
    </Route>
  );
}

export { useVerticalsRoutes };
